var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{staticClass:"section-title"},[_c('div',{staticClass:"title-left-side"},[_vm._t("icon"),_vm._v(" "),_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"title-right-side"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }